export default __webpack_public_path__ + "static/media/g-icon.f1755fd3.svg";